namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_editor, {
		flex: { grow: 0, shrink: 0, basis: '60rem' },
		width: '60rem',
		maxWidth: '100%',
		Head: { flexWrap: 'nowrap' },
		Title: { minWidth: 0 },
		Title_text: { display: 'block', minWidth: 0, flex: { shrink: 1 }, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
		Tools: { flexWrap: 'nowrap', flex: { shrink: 0 } },
		// Deck.Content is a horizontal flex view by default. Its source editor
		// must fit the page instead of keeping its intrinsic code-line width.
		Deck_content: { flexDirection: 'column', minWidth: 0, maxWidth: '100%' },
		Default: { minWidth: 0, maxWidth: '100%' },
		Readme: { minWidth: 0, maxWidth: '100%' },
		Demo: { minWidth: 0, maxWidth: '100%' },
		Save_status: { color: $shm_theme.error },
		Tree: { minWidth: 0, maxWidth: '100%' },
		Logic: { minWidth: 0, maxWidth: '100%' },
		Style: { minWidth: 0, maxWidth: '100%' },
		Dependencies: { minWidth: 0, maxWidth: '100%' },
	})
}
